import React, { useState } from "react";

import Webcam from "react-webcam";
import { connect } from "react-redux";
import { capturedData } from "../Communaute.duck"




const videoConstraints = {
  width: 1280,
  height: 600,
  facingMode: "user"
};

const WebcamCapture = ({ capturedData, onCloseModalePhoto }) => {
  const webcamRef = React.useRef(null);
  const [image, setImage] = useState('');



  const capture = React.useCallback(
    () => {
      const imageSrc = webcamRef.current.getScreenshot();
      let base64Image = imageSrc.split(';base64,').pop();
      const blob = b64toBlob(base64Image, 'image/png');

      setImage(blob)
      capturedData(blob)
      onCloseModalePhoto()
    },
    [webcamRef]
  );
  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }




  const height = "100%"
  const width = "100%"
  return (
    <>
      <Webcam
        audio={false}
        // height={height}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        width={width}
        videoConstraints={videoConstraints}
      />
      <div className="d-flex justify-content-center  ">

        <button style={{ display: "flex", justifyContent: "center", alignItems: "center" }} className="btn-gradient" onClick={capture}>Capturer</button>
      </div>
    </>
  );
};
const mapDispatchToProps = {
  capturedData

};


export default connect(
  null,
  mapDispatchToProps
)(WebcamCapture);

  // https://www.npmjs.com/package/react-webcam
